module.exports = __webpack_public_path__ + "img/box3.8fcec36c.png";